import OGoogleDocLink from './o-google-doc-link.vue'

export default OGoogleDocLink
